var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _path, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _path2, _path3, _ellipse, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgTravelMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1800 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-77);\n        filter: url(#outer-glow-3);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .67;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-90);\n        filter: url(#outer-glow-4);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-49);\n        filter: url(#outer-glow-2);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150 {\n        opacity: .42;\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-151 {\n        fill: url(#radial-gradient-135);\n      }\n\n      .cls-151, .cls-152, .cls-153, .cls-154 {\n        opacity: .61;\n      }\n\n      .cls-152 {\n        fill: url(#radial-gradient-108);\n      }\n\n      .cls-153 {\n        fill: url(#radial-gradient-158);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-144);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-143);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-140);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-142);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-149);\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-141);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-146);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-131);\n      }\n\n      .cls-20 {\n        fill: url(#radial-gradient-133);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-130);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-116);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-114);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-115);\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-110);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-111);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-112);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-113);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-147);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-160);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-139);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-134);\n      }\n\n      .cls-33 {\n        fill: url(#radial-gradient-132);\n      }\n\n      .cls-34 {\n        fill: url(#radial-gradient-137);\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient-138);\n      }\n\n      .cls-36 {\n        fill: url(#radial-gradient-136);\n      }\n\n      .cls-37 {\n        fill: url(#radial-gradient-145);\n      }\n\n      .cls-38 {\n        fill: url(#radial-gradient-163);\n      }\n\n      .cls-39 {\n        fill: url(#radial-gradient-161);\n      }\n\n      .cls-40 {\n        fill: url(#radial-gradient-162);\n      }\n\n      .cls-41 {\n        fill: url(#radial-gradient-118);\n      }\n\n      .cls-42 {\n        fill: url(#radial-gradient-119);\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient-117);\n      }\n\n      .cls-44 {\n        fill: url(#radial-gradient-106);\n      }\n\n      .cls-45 {\n        fill: url(#radial-gradient-105);\n      }\n\n      .cls-46 {\n        fill: url(#radial-gradient-109);\n      }\n\n      .cls-47 {\n        fill: url(#radial-gradient-100);\n      }\n\n      .cls-48 {\n        fill: url(#radial-gradient-103);\n      }\n\n      .cls-49 {\n        fill: url(#radial-gradient-102);\n      }\n\n      .cls-50 {\n        fill: url(#radial-gradient-107);\n      }\n\n      .cls-51 {\n        fill: url(#radial-gradient-101);\n      }\n\n      .cls-52 {\n        fill: url(#radial-gradient-104);\n      }\n\n      .cls-53 {\n        fill: url(#radial-gradient-155);\n      }\n\n      .cls-54 {\n        fill: url(#radial-gradient-151);\n      }\n\n      .cls-55 {\n        fill: url(#radial-gradient-156);\n      }\n\n      .cls-56 {\n        fill: url(#radial-gradient-153);\n      }\n\n      .cls-57 {\n        fill: url(#radial-gradient-150);\n      }\n\n      .cls-58 {\n        fill: url(#radial-gradient-152);\n      }\n\n      .cls-59 {\n        fill: url(#radial-gradient-157);\n      }\n\n      .cls-60 {\n        fill: url(#radial-gradient-154);\n      }\n\n      .cls-61 {\n        fill: url(#radial-gradient-159);\n      }\n\n      .cls-62 {\n        fill: url(#radial-gradient-126);\n      }\n\n      .cls-63 {\n        fill: url(#radial-gradient-123);\n      }\n\n      .cls-64 {\n        fill: url(#radial-gradient-124);\n      }\n\n      .cls-65 {\n        fill: url(#radial-gradient-122);\n      }\n\n      .cls-66 {\n        fill: url(#radial-gradient-120);\n      }\n\n      .cls-67 {\n        fill: url(#radial-gradient-121);\n      }\n\n      .cls-68 {\n        fill: url(#radial-gradient-127);\n      }\n\n      .cls-69 {\n        fill: url(#radial-gradient-129);\n      }\n\n      .cls-70 {\n        fill: url(#radial-gradient-128);\n      }\n\n      .cls-155 {\n        fill: url(#radial-gradient-148);\n      }\n\n      .cls-155, .cls-156, .cls-157, .cls-158 {\n        opacity: .78;\n      }\n\n      .cls-156 {\n        fill: url(#radial-gradient-125);\n      }\n\n      .cls-157 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-158 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-71 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-72 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-73 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-74 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-75 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-76 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-77 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-78 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-79 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-80 {\n        fill: url(#radial-gradient-48);\n      }\n\n      .cls-81 {\n        fill: url(#radial-gradient-47);\n      }\n\n      .cls-82 {\n        fill: url(#radial-gradient-46);\n      }\n\n      .cls-83 {\n        fill: url(#radial-gradient-45);\n      }\n\n      .cls-84 {\n        fill: url(#radial-gradient-41);\n      }\n\n      .cls-85 {\n        fill: url(#radial-gradient-40);\n      }\n\n      .cls-86 {\n        fill: url(#radial-gradient-42);\n      }\n\n      .cls-87 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-88 {\n        fill: url(#radial-gradient-59);\n      }\n\n      .cls-89 {\n        fill: url(#radial-gradient-53);\n      }\n\n      .cls-90 {\n        fill: url(#radial-gradient-54);\n      }\n\n      .cls-91 {\n        fill: url(#radial-gradient-58);\n      }\n\n      .cls-92 {\n        fill: url(#radial-gradient-56);\n      }\n\n      .cls-93 {\n        fill: url(#radial-gradient-44);\n      }\n\n      .cls-94 {\n        fill: url(#radial-gradient-43);\n      }\n\n      .cls-95 {\n        fill: url(#radial-gradient-57);\n      }\n\n      .cls-96 {\n        fill: url(#radial-gradient-36);\n      }\n\n      .cls-97 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-98 {\n        fill: url(#radial-gradient-31);\n      }\n\n      .cls-99 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-100 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-101 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-102 {\n        fill: url(#radial-gradient-33);\n      }\n\n      .cls-103 {\n        fill: url(#radial-gradient-38);\n      }\n\n      .cls-104 {\n        fill: url(#radial-gradient-39);\n      }\n\n      .cls-105 {\n        fill: url(#radial-gradient-55);\n      }\n\n      .cls-106 {\n        fill: url(#radial-gradient-50);\n      }\n\n      .cls-107 {\n        fill: url(#radial-gradient-52);\n      }\n\n      .cls-108 {\n        fill: url(#radial-gradient-34);\n      }\n\n      .cls-109 {\n        fill: url(#radial-gradient-35);\n      }\n\n      .cls-110 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-111 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-112 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-113 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-114 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-115 {\n        fill: url(#radial-gradient-71);\n      }\n\n      .cls-116 {\n        fill: url(#radial-gradient-76);\n      }\n\n      .cls-117 {\n        fill: url(#radial-gradient-73);\n      }\n\n      .cls-118 {\n        fill: url(#radial-gradient-74);\n      }\n\n      .cls-119 {\n        fill: url(#radial-gradient-61);\n      }\n\n      .cls-120 {\n        fill: url(#radial-gradient-66);\n      }\n\n      .cls-121 {\n        fill: url(#radial-gradient-60);\n      }\n\n      .cls-122 {\n        fill: url(#radial-gradient-78);\n      }\n\n      .cls-123 {\n        fill: url(#radial-gradient-79);\n      }\n\n      .cls-124 {\n        fill: url(#radial-gradient-70);\n      }\n\n      .cls-125 {\n        fill: url(#radial-gradient-72);\n      }\n\n      .cls-126 {\n        fill: url(#radial-gradient-75);\n      }\n\n      .cls-127 {\n        fill: url(#radial-gradient-68);\n      }\n\n      .cls-128 {\n        fill: url(#radial-gradient-69);\n      }\n\n      .cls-129 {\n        fill: url(#radial-gradient-62);\n      }\n\n      .cls-130 {\n        fill: url(#radial-gradient-64);\n      }\n\n      .cls-131 {\n        fill: url(#radial-gradient-65);\n      }\n\n      .cls-132 {\n        fill: url(#radial-gradient-63);\n      }\n\n      .cls-133 {\n        fill: url(#radial-gradient-67);\n      }\n\n      .cls-134 {\n        fill: url(#radial-gradient-93);\n      }\n\n      .cls-135 {\n        fill: url(#radial-gradient-95);\n      }\n\n      .cls-136 {\n        fill: url(#radial-gradient-91);\n      }\n\n      .cls-137 {\n        fill: url(#radial-gradient-97);\n      }\n\n      .cls-138 {\n        fill: url(#radial-gradient-96);\n      }\n\n      .cls-139 {\n        fill: url(#radial-gradient-94);\n      }\n\n      .cls-140 {\n        fill: url(#radial-gradient-99);\n      }\n\n      .cls-141 {\n        fill: url(#radial-gradient-98);\n      }\n\n      .cls-142 {\n        fill: url(#radial-gradient-92);\n      }\n\n      .cls-143 {\n        fill: url(#radial-gradient-81);\n      }\n\n      .cls-144 {\n        fill: url(#radial-gradient-88);\n      }\n\n      .cls-145 {\n        fill: url(#radial-gradient-84);\n      }\n\n      .cls-146 {\n        fill: url(#radial-gradient-86);\n      }\n\n      .cls-147 {\n        fill: url(#radial-gradient-89);\n      }\n\n      .cls-148 {\n        fill: url(#radial-gradient-80);\n      }\n\n      .cls-149 {\n        fill: url(#radial-gradient-83);\n      }\n\n      .cls-150 {\n        fill: url(#radial-gradient-85);\n      }\n\n      .cls-154 {\n        fill: url(#radial-gradient-82);\n      }\n\n      .cls-159 {\n        fill: url(#radial-gradient-37);\n      }\n\n      .cls-159, .cls-160, .cls-161, .cls-162 {\n        opacity: .17;\n      }\n\n      .cls-160 {\n        fill: url(#radial-gradient-32);\n      }\n\n      .cls-161 {\n        fill: url(#radial-gradient-51);\n      }\n\n      .cls-162 {\n        fill: url(#radial-gradient-87);\n      }\n\n      .cls-163 {\n        fill: url(#radial-gradient);\n        filter: url(#outer-glow-1);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 523.98,
    cy: 131.88,
    fx: 523.98,
    fy: 131.88,
    r: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    x: 468.92,
    y: 76.73,
    width: 110.16,
    height: 110.16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 580.61,
    cy: 305.26,
    fx: 580.61,
    fy: 305.26,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 469.52,
    cy: 313.88,
    fx: 469.52,
    fy: 313.88,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 469.52,
    cy: 313.88,
    fx: 469.52,
    fy: 313.88,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 469.52,
    cy: 313.88,
    fx: 469.52,
    fy: 313.88,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 469.52,
    cy: 313.88,
    fx: 469.52,
    fy: 313.88,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 517.8,
    cy: 363.07,
    fx: 517.8,
    fy: 363.07,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 419.75,
    cy: 381.49,
    fx: 419.75,
    fy: 381.49,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 759.52,
    cy: 222.23,
    fx: 759.52,
    fy: 222.23,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 702.11,
    cy: 283.44,
    fx: 702.11,
    fy: 283.44,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 651.37,
    cy: 449.83,
    fx: 651.37,
    fy: 449.83,
    r: 4.31,
    gradientTransform: "translate(-97.19 1106.33) rotate(-98.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 666.44,
    cy: 549.82,
    fx: 666.44,
    fy: 549.82,
    r: 4.25,
    gradientTransform: "translate(209.51 1396.61) rotate(-121.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 609.75,
    cy: 610.26,
    fx: 609.75,
    fy: 610.26,
    r: 4.25,
    gradientTransform: "translate(209.51 1396.61) rotate(-121.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 513.83,
    cy: 835.29,
    fx: 513.83,
    fy: 835.29,
    r: 5.07,
    gradientTransform: "translate(52.65 1551.41) rotate(-121.78) scale(1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 450.41,
    cy: 697.64,
    fx: 450.41,
    fy: 697.64,
    r: 4.25,
    gradientTransform: "translate(-444.02 2210.04) rotate(-121.78) scale(2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 123.25,
    cy: 806.23,
    fx: 123.25,
    fy: 806.23,
    r: 3.66,
    gradientTransform: "translate(978.35 1343.31) rotate(171.06) scale(1.38)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -176.53,
    cy: 912.42,
    fx: -176.53,
    fy: 912.42,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 118.18,
    cy: 1120.6,
    fx: 118.18,
    fy: 1120.6,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -6.87,
    cy: 1130.29,
    fx: -6.87,
    fy: 1130.29,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -6.87,
    cy: 1130.29,
    fx: -6.87,
    fy: 1130.29,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -6.87,
    cy: 1130.29,
    fx: -6.87,
    fy: 1130.29,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -6.87,
    cy: 1130.29,
    fx: -6.87,
    fy: 1130.29,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 47.48,
    cy: 1185.66,
    fx: 47.48,
    fy: 1185.66,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 234.07,
    cy: 1331.25,
    fx: 234.07,
    fy: 1331.25,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 319.56,
    cy: 1027.13,
    fx: 319.56,
    fy: 1027.13,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 254.93,
    cy: 1096.03,
    fx: 254.93,
    fy: 1096.03,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 197.82,
    cy: 1283.33,
    fx: 197.82,
    fy: 1283.33,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: -346.38,
    cy: 1309.41,
    fx: -346.38,
    fy: 1309.41,
    r: 4.85,
    gradientTransform: "translate(487.46 816.39) rotate(171.06) scale(.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: -200.63,
    cy: 635.79,
    fx: -200.63,
    fy: 635.79,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 250.08,
    cy: 961.24,
    fx: 250.08,
    fy: 961.24,
    r: 4.85,
    gradientTransform: "translate(1201.21 896.65) rotate(139.28)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 303.13,
    cy: 943.02,
    fx: 303.13,
    fy: 943.02,
    r: 3.89,
    gradientTransform: "translate(171.57 1272.21) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 378.21,
    cy: 1029.5,
    fx: 378.21,
    fy: 1029.5,
    r: 5.15,
    gradientTransform: "translate(171.57 1272.21) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 592.08,
    cy: 930.24,
    fx: 592.08,
    fy: 930.24,
    r: 5.15,
    gradientTransform: "translate(171.57 1272.21) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 427.06,
    cy: 1188.74,
    fx: 427.06,
    fy: 1188.74,
    r: 5.15,
    gradientTransform: "translate(-738.21 1884.59) rotate(-112.23) scale(1.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 286.93,
    cy: 787.52,
    fx: 286.93,
    fy: 787.52,
    r: 5.15,
    gradientTransform: "translate(-323.11 766.6) rotate(-80.45) scale(1.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 518.3,
    cy: 860.26,
    fx: 518.3,
    fy: 860.26,
    r: 5.15,
    gradientTransform: "translate(171.57 1272.21) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 208.84,
    cy: 60.63,
    fx: 208.84,
    fy: 60.63,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 90.86,
    cy: 69.78,
    fx: 90.86,
    fy: 69.78,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 90.86,
    cy: 69.78,
    fx: 90.86,
    fy: 69.78,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 90.86,
    cy: 69.78,
    fx: 90.86,
    fy: 69.78,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 90.86,
    cy: 69.78,
    fx: 90.86,
    fy: 69.78,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 142.14,
    cy: 122.03,
    fx: 142.14,
    fy: 122.03,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 38.01,
    cy: 141.59,
    fx: 38.01,
    fy: 141.59,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 337.87,
    cy: 37.46,
    fx: 337.87,
    fy: 37.46,
    r: 4.58,
    gradientTransform: "translate(1064.59 -15.48) rotate(94.1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 207.56,
    cy: 489.99,
    fx: 207.56,
    fy: 489.99,
    r: 4.58,
    gradientTransform: "translate(1679.12 50.14) rotate(99.55) scale(1.64)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 586.52,
    cy: 1821.5,
    fx: 586.52,
    fy: 1821.5,
    r: 5.15,
    gradientTransform: "translate(27.54 -1431.97) rotate(-24.02) scale(1.33 1.32) skewX(.63)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -2454.99,
    cy: -2121.77,
    fx: -2454.99,
    fy: -2121.77,
    r: 4.85,
    gradientTransform: "translate(-1928.53 -341.17) rotate(156.54)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -842.74,
    cy: 2930.62,
    fx: -842.74,
    fy: 2930.62,
    r: 5.15,
    gradientTransform: "translate(-3207.76 -1380.21) rotate(-80.45) scale(1.64)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 1190.8,
    cy: -3495.68,
    fx: 1190.8,
    fy: -3495.68,
    r: 6,
    gradientTransform: "translate(-1730.19 -1369.06) rotate(101.81)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    x: 1396.76,
    y: 460.73,
    width: 102.24,
    height: 102.24,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 509.41,
    cy: -3558.99,
    fx: 509.41,
    fy: -3558.99,
    r: 3.46,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 576.11,
    cy: -3482.16,
    fx: 576.11,
    fy: -3482.16,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 458.12,
    cy: -3473.01,
    fx: 458.12,
    fy: -3473.01,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 458.12,
    cy: -3473.01,
    fx: 458.12,
    fy: -3473.01,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 458.12,
    cy: -3473.01,
    fx: 458.12,
    fy: -3473.01,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 458.12,
    cy: -3473.01,
    fx: 458.12,
    fy: -3473.01,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 509.41,
    cy: -3420.77,
    fx: 509.41,
    fy: -3420.77,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 426.94,
    cy: -1011.33,
    fx: 426.94,
    fy: -1011.33,
    r: 4.58,
    gradientTransform: "translate(2737.6 -1567.78) rotate(-170.46) scale(2.51)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 705.14,
    cy: -3505.34,
    fx: 705.14,
    fy: -3505.34,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 433.3,
    cy: -2634.19,
    fx: 433.3,
    fy: -2634.19,
    r: 4.58,
    gradientTransform: "translate(2543.07 -2645.62) rotate(-170.45) scale(1.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 700.56,
    cy: -3632.51,
    fx: 700.56,
    fy: -3632.51,
    r: 4.58,
    gradientTransform: "translate(-1788.47 -1252.78) rotate(111.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: -2656.45,
    cy: 3282.69,
    fx: -2656.45,
    fy: 3282.69,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: -2731.73,
    cy: 3288.53,
    fx: -2731.73,
    fy: 3288.53,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: -2731.73,
    cy: 3288.53,
    fx: -2731.73,
    fy: 3288.53,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: -2731.73,
    cy: 3288.53,
    fx: -2731.73,
    fy: 3288.53,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: -2731.73,
    cy: 3288.53,
    fx: -2731.73,
    fy: 3288.53,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: -2699.01,
    cy: 3321.86,
    fx: -2699.01,
    fy: 3321.86,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: -2765.46,
    cy: 3334.35,
    fx: -2765.46,
    fy: 3334.35,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: -2608.5,
    cy: 3380.66,
    fx: -2608.5,
    fy: 3380.66,
    r: 2.92,
    gradientTransform: "translate(-2654.31 537.32) rotate(-126.69)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: -4989.06,
    cy: 5071.79,
    fx: -4989.06,
    fy: 5071.79,
    r: 2.92,
    gradientTransform: "translate(-1746.49 -1580.59) rotate(-98.94) scale(.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: -3421.34,
    cy: 1988.89,
    fx: -3421.34,
    fy: 1988.89,
    r: 2.88,
    gradientTransform: "translate(-2247.72 651.43) rotate(-149.52)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: -2724.31,
    cy: 3292.34,
    fx: -2724.31,
    fy: 3292.34,
    r: 4.25,
    gradientTransform: "translate(-2827.77 221.58) rotate(-121.25)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: -2300.86,
    cy: 3099.54,
    fx: -2300.86,
    fy: 3099.54,
    r: 5.07,
    gradientTransform: "translate(1950.18 -3756.23) rotate(-31.78) scale(1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: -1540.38,
    cy: 626.41,
    fx: -1540.38,
    fy: 626.41,
    r: 2.92,
    gradientTransform: "translate(1279.53 1989.96) rotate(119.79)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: -2878.39,
    cy: 405.99,
    fx: -2878.39,
    fy: 405.99,
    r: 2.92,
    gradientTransform: "translate(-33.74 865.88) rotate(171.06) scale(.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: -1241.34,
    cy: -31.34,
    fx: -1241.34,
    fy: -31.34,
    r: 2.88,
    gradientTransform: "translate(1221.88 1571.62) rotate(96.95)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: -442.08,
    cy: 431.72,
    fx: -442.08,
    fy: 431.72,
    r: 2.88,
    gradientTransform: "translate(1133.06 1575.98) rotate(148.22) scale(2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: -2133.67,
    cy: 767.03,
    fx: -2133.67,
    fy: 767.03,
    r: 6.75,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    x: 1611.56,
    y: 37.85,
    width: 103.68,
    height: 103.68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: -1990.92,
    cy: 510.59,
    fx: -1990.92,
    fy: 510.59,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: -1990.92,
    cy: 510.59,
    fx: -1990.92,
    fy: 510.59,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: -1990.92,
    cy: 510.59,
    fx: -1990.92,
    fy: 510.59,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: -1990.92,
    cy: 510.59,
    fx: -1990.92,
    fy: 510.59,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: -1943.24,
    cy: 559.16,
    fx: -1943.24,
    fy: 559.16,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: -2040.06,
    cy: 577.35,
    fx: -2040.06,
    fy: 577.35,
    r: 4.25,
    gradientTransform: "translate(1059.25 2275.02) rotate(125.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: -2056.56,
    cy: 1208.28,
    fx: -2056.56,
    fy: 1208.28,
    r: 3.89,
    gradientTransform: "translate(959.56 2358.55) rotate(134.77)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: -1512.43,
    cy: 989.79,
    fx: -1512.43,
    fy: 989.79,
    r: 5.15,
    gradientTransform: "translate(-616.42 1183.69) rotate(-170.45) scale(1.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: 3154.98,
    cy: 98.5,
    fx: 3154.98,
    fy: 98.5,
    r: 4.11,
    gradientTransform: "translate(-464.47 -2556.8) rotate(54.74)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: 3234.41,
    cy: 189.99,
    fx: 3234.41,
    fy: 189.99,
    r: 5.45,
    gradientTransform: "translate(-464.47 -2556.8) rotate(54.74)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: -434.3,
    cy: 3424.35,
    fx: -434.3,
    fy: 3424.35,
    r: 2.88,
    gradientTransform: "translate(-1238.06 -1702.93) rotate(-67.6)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: -60.55,
    cy: 2065.11,
    fx: -60.55,
    fy: 2065.11,
    r: 2.88,
    gradientTransform: "translate(-481.26 -3755.03) rotate(-31.78) scale(2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: 213.92,
    cy: 3428.24,
    fx: 213.92,
    fy: 3428.24,
    r: 6.75,
    gradientTransform: "translate(-893.98 -2337.62) rotate(-39.33)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-4",
    x: 1392.44,
    y: 126.65,
    width: 103.68,
    height: 103.92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: 699.84,
    cy: 3443.33,
    fx: 699.84,
    fy: 3443.33,
    r: 3.89,
    gradientTransform: "translate(-775.64 -2391.58) rotate(-29.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: 589.45,
    cy: 2694.17,
    fx: 589.45,
    fy: 2694.17,
    r: 5.15,
    gradientTransform: "translate(1410.56 -3542.54) rotate(9.55) scale(1.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: -360.54,
    cy: -773.57,
    fx: -360.54,
    fy: -773.57,
    r: 3.66,
    gradientTransform: "translate(-83.25 -426.1) rotate(145.93) scale(1.83) skewX(-.84)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: -869.67,
    cy: -1549.09,
    fx: -869.67,
    fy: -1549.09,
    r: 4.85,
    gradientTransform: "translate(-447.65 -613.37) rotate(145.93) scale(1.33) skewX(-.84)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: 865.4,
    cy: -739.04,
    fx: 865.4,
    fy: -739.04,
    r: 4.58,
    gradientTransform: "translate(3451.97 -1126.84) rotate(-178.01) scale(2.19 2.16) skewX(-.06)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: -1543.37,
    cy: 4730.21,
    fx: -1543.37,
    fy: 4730.21,
    r: 3.89,
    gradientTransform: "translate(-3874.91 1172.19) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: -1254.42,
    cy: 4717.42,
    fx: -1254.42,
    fy: 4717.42,
    r: 5.15,
    gradientTransform: "translate(-3874.91 1172.19) rotate(-112.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: -629.63,
    cy: 3355.96,
    fx: -629.63,
    fy: 3355.96,
    r: 5.15,
    gradientTransform: "translate(-4784.69 1784.57) rotate(-112.23) scale(1.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: -1003.07,
    cy: 4775.66,
    fx: -1003.07,
    fy: 4775.66,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: -1003.07,
    cy: 4775.66,
    fx: -1003.07,
    fy: 4775.66,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: -1003.07,
    cy: 4775.66,
    fx: -1003.07,
    fy: 4775.66,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: -1003.07,
    cy: 4775.66,
    fx: -1003.07,
    fy: 4775.66,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: -954.79,
    cy: 4824.85,
    fx: -954.79,
    fy: 4824.85,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: -1052.84,
    cy: 4843.28,
    fx: -1052.84,
    fy: 4843.28,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: -821.22,
    cy: 4911.62,
    fx: -821.22,
    fy: 4911.62,
    r: 4.31,
    gradientTransform: "translate(-3429.31 2594.45) rotate(-127.47)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: -2048.23,
    cy: 7602.63,
    fx: -2048.23,
    fy: 7602.63,
    r: 4.31,
    gradientTransform: "translate(-3576.47 84.2) rotate(-98.94) scale(.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: -2596.66,
    cy: 4148.54,
    fx: -2596.66,
    fy: 4148.54,
    r: 4.98,
    gradientTransform: "translate(-3021.2 2702.98) rotate(-150.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: -2638.88,
    cy: 4187.4,
    fx: -2638.88,
    fy: 4187.4,
    r: 2.9,
    gradientTransform: "translate(-3021.2 2702.98) rotate(-150.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: -2422.34,
    cy: 4090.37,
    fx: -2422.34,
    fy: 4090.37,
    r: 4.25,
    gradientTransform: "translate(-3021.2 2702.98) rotate(-150.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: -2479.03,
    cy: 4150.81,
    fx: -2479.03,
    fy: 4150.81,
    r: 4.25,
    gradientTransform: "translate(-3021.2 2702.98) rotate(-150.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: -2093.78,
    cy: 3824.28,
    fx: -2093.78,
    fy: 3824.28,
    r: 5.07,
    gradientTransform: "translate(-3843.73 484.3) rotate(-121.78) scale(1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-112",
    cx: -1009.53,
    cy: 2371.08,
    fx: -1009.53,
    fy: 2371.08,
    r: 4.25,
    gradientTransform: "translate(-4255.86 1255.85) rotate(-121.78) scale(2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-113",
    cx: -2698.01,
    cy: -2574.3,
    fx: -2698.01,
    fy: -2574.3,
    r: 4.85,
    gradientTransform: "translate(-2388.76 1790.05) rotate(110.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-114",
    cx: -2767.48,
    cy: -2640.19,
    fx: -2767.48,
    fy: -2640.19,
    r: 4.85,
    gradientTransform: "translate(-2388.76 1790.05) rotate(110.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-115",
    cx: -2155.73,
    cy: 4946.77,
    fx: -2155.73,
    fy: 4946.77,
    r: 3.89,
    gradientTransform: "translate(-3113.96 2611.81) rotate(-140.76)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-116",
    cx: -1588.03,
    cy: 3840.64,
    fx: -1588.03,
    fy: 3840.64,
    r: 5.15,
    gradientTransform: "translate(-3120.32 -2722.55) rotate(-80.45) scale(1.31)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-117",
    cx: -1940.57,
    cy: 4864.01,
    fx: -1940.57,
    fy: 4864.01,
    r: 5.15,
    gradientTransform: "translate(-3113.96 2611.81) rotate(-140.76)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-118",
    cx: -972.48,
    cy: 6253.66,
    fx: -972.48,
    fy: 6253.66,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-119",
    cx: -1083.58,
    cy: 6262.28,
    fx: -1083.58,
    fy: 6262.28,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-120",
    cx: -1083.58,
    cy: 6262.28,
    fx: -1083.58,
    fy: 6262.28,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-121",
    cx: -1083.58,
    cy: 6262.28,
    fx: -1083.58,
    fy: 6262.28,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-122",
    cx: -1083.58,
    cy: 6262.28,
    fx: -1083.58,
    fy: 6262.28,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-123",
    cx: -1035.29,
    cy: 6311.47,
    fx: -1035.29,
    fy: 6311.47,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-124",
    cx: -1133.35,
    cy: 6329.89,
    fx: -1133.35,
    fy: 6329.89,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-125",
    cx: -850.99,
    cy: 6231.84,
    fx: -850.99,
    fy: 6231.84,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-126",
    cx: -901.73,
    cy: 6398.23,
    fx: -901.73,
    fy: 6398.23,
    r: 4.31,
    gradientTransform: "translate(179.46 -5639.94) rotate(-8.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-127",
    cx: -2186.96,
    cy: 10164.06,
    fx: -2186.96,
    fy: 10164.06,
    r: 4.31,
    gradientTransform: "translate(344.26 -5355.45) rotate(-8.94) scale(.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-128",
    cx: -3073.49,
    cy: 5429.22,
    fx: -3073.49,
    fy: 5429.22,
    r: 4.25,
    gradientTransform: "translate(-110.82 -5333.23) rotate(-31.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-129",
    cx: -3130.18,
    cy: 5489.65,
    fx: -3130.18,
    fy: 5489.65,
    r: 4.25,
    gradientTransform: "translate(-110.82 -5333.23) rotate(-31.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-130",
    cx: -1317.29,
    cy: 3003.89,
    fx: -1317.29,
    fy: 3003.89,
    r: 4.25,
    gradientTransform: "translate(-924.24 -5986.77) rotate(-31.78) scale(2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-131",
    cx: -3919.41,
    cy: -3425.59,
    fx: -3919.41,
    fy: -3425.59,
    r: 4.85,
    gradientTransform: "translate(389.15 -4341.54) rotate(-130.72)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-132",
    cx: -3988.88,
    cy: -3491.48,
    fx: -3988.88,
    fy: -3491.48,
    r: 4.85,
    gradientTransform: "translate(389.15 -4341.54) rotate(-130.72)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-133",
    cx: 1263.02,
    cy: 6135.59,
    fx: 1263.02,
    fy: 6135.59,
    r: 4.31,
    gradientTransform: "translate(2160.72 -5416.57) rotate(23.83)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-134",
    cx: -1150.8,
    cy: 6085.46,
    fx: -1150.8,
    fy: 6085.46,
    r: 4.98,
    gradientTransform: "translate(1750.62 -5315.83) rotate(1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-135",
    cx: -1193.03,
    cy: 6124.32,
    fx: -1193.03,
    fy: 6124.32,
    r: 2.9,
    gradientTransform: "translate(1750.62 -5315.83) rotate(1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-136",
    cx: -976.48,
    cy: 6027.29,
    fx: -976.48,
    fy: 6027.29,
    r: 4.25,
    gradientTransform: "translate(1750.62 -5315.83) rotate(1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-137",
    cx: -1033.18,
    cy: 6087.73,
    fx: -1033.18,
    fy: 6087.73,
    r: 4.25,
    gradientTransform: "translate(1750.62 -5315.83) rotate(1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-138",
    cx: -873.13,
    cy: 5459.49,
    fx: -873.13,
    fy: 5459.49,
    r: 5.07,
    gradientTransform: "translate(6600.84 -1609.8) rotate(58.22) scale(1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-139",
    cx: -4836.08,
    cy: -1446.99,
    fx: -4836.08,
    fy: -1446.99,
    r: 4.85,
    gradientTransform: "translate(1634.16 -4211.35) rotate(-97.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-140",
    cx: -4905.55,
    cy: -1512.88,
    fx: -4905.55,
    fy: -1512.88,
    r: 4.85,
    gradientTransform: "translate(1634.16 -4211.35) rotate(-97.94)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-141",
    cx: 23.33,
    cy: 5702.08,
    fx: 23.33,
    fy: 5702.08,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-142",
    cx: -87.77,
    cy: 5710.69,
    fx: -87.77,
    fy: 5710.69,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-143",
    cx: -87.77,
    cy: 5710.69,
    fx: -87.77,
    fy: 5710.69,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-144",
    cx: -87.77,
    cy: 5710.69,
    fx: -87.77,
    fy: 5710.69,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-145",
    cx: -87.77,
    cy: 5710.69,
    fx: -87.77,
    fy: 5710.69,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-146",
    cx: -39.48,
    cy: 5759.88,
    fx: -39.48,
    fy: 5759.88,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-147",
    cx: -137.53,
    cy: 5778.31,
    fx: -137.53,
    fy: 5778.31,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-148",
    cx: 144.82,
    cy: 5680.25,
    fx: 144.82,
    fy: 5680.25,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-149",
    cx: 94.08,
    cy: 5846.65,
    fx: 94.08,
    fy: 5846.65,
    r: 4.31,
    gradientTransform: "translate(179.46 6568.66) rotate(8.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-150",
    cx: -471.34,
    cy: 9213.65,
    fx: -471.34,
    fy: 9213.65,
    r: 4.31,
    gradientTransform: "translate(344.26 6284.17) rotate(8.94) scale(.58 -.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-151",
    cx: -1941.66,
    cy: 5307.34,
    fx: -1941.66,
    fy: 5307.34,
    r: 4.25,
    gradientTransform: "translate(-110.82 6261.95) rotate(31.78) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-152",
    cx: -1998.35,
    cy: 5367.78,
    fx: -1998.35,
    fy: 5367.78,
    r: 4.25,
    gradientTransform: "translate(-110.82 6261.95) rotate(31.78) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-153",
    cx: -782.31,
    cy: 2946.3,
    fx: -782.31,
    fy: 2946.3,
    r: 4.25,
    gradientTransform: "translate(-924.24 6915.49) rotate(31.78) scale(2.12 -2.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-154",
    cx: -3974.89,
    cy: -2288.57,
    fx: -3974.89,
    fy: -2288.57,
    r: 4.85,
    gradientTransform: "translate(389.15 5270.26) rotate(130.72) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-155",
    cx: -4044.36,
    cy: -2354.46,
    fx: -4044.36,
    fy: -2354.46,
    r: 4.85,
    gradientTransform: "translate(389.15 5270.26) rotate(130.72) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-156",
    cx: 1801.72,
    cy: 5132.74,
    fx: 1801.72,
    fy: 5132.74,
    r: 4.31,
    gradientTransform: "translate(2160.72 6345.29) rotate(-23.83) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-157",
    cx: -265.12,
    cy: 5370.29,
    fx: -265.12,
    fy: 5370.29,
    r: 4.98,
    gradientTransform: "translate(1750.62 6244.55) rotate(-1) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-158",
    cx: -307.35,
    cy: 5409.16,
    fx: -307.35,
    fy: 5409.16,
    r: 2.9,
    gradientTransform: "translate(1750.62 6244.55) rotate(-1) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-159",
    cx: -90.81,
    cy: 5312.13,
    fx: -90.81,
    fy: 5312.13,
    r: 4.25,
    gradientTransform: "translate(1750.62 6244.55) rotate(-1) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-160",
    cx: -147.5,
    cy: 5372.56,
    fx: -147.5,
    fy: 5372.56,
    r: 4.25,
    gradientTransform: "translate(1750.62 6244.55) rotate(-1) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-161",
    cx: -125.42,
    cy: 4855.73,
    fx: -125.42,
    fy: 4855.73,
    r: 5.07,
    gradientTransform: "translate(-1445.91 5679.86) rotate(31.78) scale(1.18 -1.18)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-162",
    cx: -4267.23,
    cy: -460.94,
    fx: -4267.23,
    fy: -460.94,
    r: 4.85,
    gradientTransform: "translate(1634.16 5140.08) rotate(97.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-163",
    cx: -4100.91,
    cy: -2217.16,
    fx: -4100.91,
    fy: -2217.16,
    r: 4.85,
    gradientTransform: "translate(1634.16 5140.08) rotate(97.94) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-163",
    cx: 523.98,
    cy: 131.88,
    r: 9.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 114.14,
    cy: 485.34,
    r: 4.31
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 139.91,
    cy: 593.74,
    r: 4.31
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 139.91,
    cy: 593.74,
    r: 4.31
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 139.91,
    cy: 593.74,
    r: 4.31
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 139.91,
    cy: 593.74,
    r: 4.31
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181,
    cy: 538.4,
    r: 4.31
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 214.44,
    cy: 632.4,
    r: 4.31
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 4.31,
    cy: 321.5,
    r: 4.31
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-157",
    cx: 73.7,
    cy: 368.71,
    r: 4.31
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 245.96,
    cy: 392.98,
    r: 4.31
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 325.98,
    cy: 540.53,
    r: 4.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 407.21,
    cy: 556.9,
    r: 4.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-74",
    cx: 573.27,
    cy: 512.97,
    r: 6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 308.94,
    cy: 622.78,
    r: 9
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-72",
    cx: 636.72,
    cy: 268.31,
    r: 5.06,
    transform: "translate(-45.86 375.51) rotate(-31.78)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 739.84,
    cy: 89.92,
    r: 4.85
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-75",
    cx: 380.67,
    cy: 124.37,
    r: 4.85
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 469.12,
    cy: 35.45,
    r: 4.85
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 469.12,
    cy: 35.45,
    r: 4.85
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-99",
    cx: 469.12,
    cy: 35.45,
    r: 4.85
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-110",
    cx: 469.12,
    cy: 35.45,
    r: 4.85
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 391.81,
    cy: 28.94,
    r: 4.85
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-111",
    cx: 155.41,
    cy: 40.3,
    r: 4.85
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 288.99,
    cy: 326.58,
    r: 4.85
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-158",
    cx: 293.04,
    cy: 232.2,
    r: 4.85
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-100",
    cx: 214.15,
    cy: 52.98,
    r: 4.85
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-113",
    cx: 567.96,
    cy: 34.43,
    r: 2.81,
    transform: "translate(67 304.25) rotate(-31.78)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 938.55,
    cy: 283.88,
    r: 4.85
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-97",
    cx: 384.63,
    cy: 331.2,
    r: 4.85
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 929.81,
    cy: 634.83,
    r: 3.89
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-160",
    cx: 981.45,
    cy: 532.62,
    r: 5.15
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-102",
    cx: 808.66,
    cy: 372.2,
    r: 5.15
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-108",
    cx: 902.36,
    cy: 408.05,
    r: 9
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-109",
    cx: 757.71,
    cy: 566.79,
    r: 6.75,
    transform: "translate(-184.9 483.96) rotate(-31.78)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 771.8,
    cy: 466.97,
    r: 5.15
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-159",
    cx: 989.18,
    cy: 188.49,
    r: 4.58
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 988.49,
    cy: 70.16,
    r: 4.58
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 988.49,
    cy: 70.16,
    r: 4.58
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-85",
    cx: 988.49,
    cy: 70.16,
    r: 4.58
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-84",
    cx: 988.49,
    cy: 70.16,
    r: 4.58
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-86",
    cx: 932.71,
    cy: 117.57,
    r: 4.58
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 920.64,
    cy: 12.3,
    r: 4.58
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-93",
    cx: 1003.07,
    cy: 318.85,
    r: 4.58
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 830.66,
    cy: 252.46,
    r: 7.5,
    transform: "translate(-20.21 79.98) rotate(-5.45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1751.9,433.27c1.57,3.41.03,7.43-3.44,8.98-3.46,1.54-7.54.03-9.11-3.39-1.57-3.41-.03-7.43,3.44-8.98,3.46-1.54,7.54-.03,9.11,3.39Z"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 1168.27,
    cy: 627.73,
    r: 4.85
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 1300.3,
    cy: 778.75,
    r: 8.44,
    transform: "translate(-153.74 350.95) rotate(-14.52)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1447.88,
    cy: 511.8,
    r: 6
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 1340.75,
    cy: 517.5,
    r: 3.46
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-161",
    cx: 1244.91,
    cy: 551.65,
    r: 4.58
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 1279.35,
    cy: 438.44,
    r: 4.58
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 1279.35,
    cy: 438.44,
    r: 4.58
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-90",
    cx: 1279.35,
    cy: 438.44,
    r: 4.58
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 1279.35,
    cy: 438.44,
    r: 4.58
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-92",
    cx: 1212.02,
    cy: 467.18,
    r: 4.58
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-95",
    cx: 1257.86,
    cy: 760.72,
    r: 11.5,
    transform: "translate(255.86 1836.32) rotate(-78.19)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 1219.52,
    cy: 680.26,
    r: 4.58
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-88",
    cx: 1409.83,
    cy: 666.69,
    r: 6,
    transform: "translate(468.77 1910.29) rotate(-78.19)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-121",
    cx: 1339.63,
    cy: 722.31,
    r: 4.58
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 1565.19,
    cy: 706.36,
    r: 2.92
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-129",
    cx: 1614.85,
    cy: 763.25,
    r: 2.92
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 1614.85,
    cy: 763.25,
    r: 2.92
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 1614.85,
    cy: 763.25,
    r: 2.92
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-131",
    cx: 1614.85,
    cy: 763.25,
    r: 2.92
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 1622.03,
    cy: 717.09,
    r: 2.92
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 1671.74,
    cy: 762.92,
    r: 2.92
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-127",
    cx: 1615.11,
    cy: 609.38,
    r: 2.92
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-128",
    cx: 1611.29,
    cy: 822.65,
    r: 1.69,
    transform: "translate(-197.72 844.76) rotate(-27.75)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 1709.65,
    cy: 672.63,
    r: 2.88
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-115",
    cx: 1400.21,
    cy: 842.58,
    r: 4.25
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 1566.66,
    cy: 800.18,
    r: 6,
    transform: "translate(752.16 2359.44) rotate(-89.48)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-117",
    cx: 1501.2,
    cy: 341.93,
    r: 2.92
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 1580.1,
    cy: 373.52,
    r: 1.69,
    transform: "translate(300.13 1372.47) rotate(-51.27)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-126",
    cx: 1403.28,
    cy: 343.2,
    r: 2.88
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 1447.16,
    cy: 306.95,
    r: 6.1,
    transform: "translate(302.29 1243.84) rotate(-51.27)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1663.38,
    cy: 89.63,
    r: 6.75
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 1790.53,
    cy: 354.16,
    r: 4.25
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 1790.53,
    cy: 354.16,
    r: 4.25
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 1790.53,
    cy: 354.16,
    r: 4.25
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 1790.53,
    cy: 354.16,
    r: 4.25
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-154",
    cx: 1723.35,
    cy: 365.1,
    r: 4.25
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 1764.34,
    cy: 275.51,
    r: 4.25
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 1550.18,
    cy: 47.59,
    r: 3.89
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 1554.78,
    cy: 232.59,
    r: 6.75,
    transform: "translate(467.98 1368.51) rotate(-54.77)"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-146",
    cx: 1276.38,
    cy: 76.26,
    r: 4.11
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 1247.53,
    cy: 193.93,
    r: 5.45
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-144",
    cx: 1762.43,
    cy: 3.49,
    r: 2.88
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-147",
    cx: 1710.48,
    cy: 26.75,
    r: 6.1,
    transform: "translate(307.94 1006.22) rotate(-35.82)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1444.2,
    cy: 178.63,
    r: 6.75
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 1542.11,
    cy: 249.31,
    r: 3.89
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 1586.94,
    cy: 69.76,
    r: 6.75,
    transform: "translate(315.19 1021.55) rotate(-39.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1237.6,395.61c-2.04-3.11-1.19-7.31,1.88-9.39s7.22-1.24,9.25,1.86,1.19,7.31-1.88,9.39c-3.07,2.08-7.22,1.24-9.25-1.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1629.92,464.82c-1.95-2.97-1.14-7,1.8-8.99,2.94-1.99,6.91-1.19,8.86,1.78s1.14,7-1.8,8.99-6.91,1.19-8.86-1.78Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-135",
    cx: 1499.37,
    cy: 402.13,
    rx: 10.03,
    ry: 9.88,
    transform: "translate(864.08 1818.54) rotate(-80.86)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 1087.61,
    cy: 811.27,
    r: 3.89
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 966.46,
    cy: 548.64,
    r: 5.15
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 1060.16,
    cy: 584.49,
    r: 9
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 971.15,
    cy: 485.19,
    r: 4.31
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 971.15,
    cy: 485.19,
    r: 4.31
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 971.15,
    cy: 485.19,
    r: 4.31
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 971.15,
    cy: 485.19,
    r: 4.31
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 980.82,
    cy: 416.94,
    r: 4.31
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 1055.09,
    cy: 483.55,
    r: 4.31
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 968.43,
    cy: 258.15,
    r: 4.31
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 967.09,
    cy: 572.91,
    r: 2.5,
    transform: "translate(-156.2 531.51) rotate(-28.53)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 1289.45,
    cy: 385.38,
    r: 4.98
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 1345.38,
    cy: 372.54,
    r: 2.9
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 1109.21,
    cy: 349.56,
    r: 4.25
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 1188.39,
    cy: 325.14,
    r: 4.25
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 1313.3,
    cy: 207.24,
    r: 6,
    transform: "translate(60.51 652.46) rotate(-28.53)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 1133.52,
    cy: 429.96,
    r: 9,
    transform: "translate(-67.71 593.64) rotate(-28.53)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 974.52,
    cy: 179.26,
    r: 4.85
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 1060.75,
    cy: 137.64,
    r: 4.85
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1684.75,
    cy: 143.99,
    r: 3.89
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1501.05,
    cy: 166.42,
    r: 6.75,
    transform: "translate(612.95 1387.95) rotate(-60.31)"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 1465.75,
    cy: 71.99,
    r: 5.15
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 190.57,
    cy: 688.87,
    r: 4.31
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 82.16,
    cy: 714.65,
    r: 4.31
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-66",
    cx: 82.16,
    cy: 714.65,
    r: 4.31
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 82.16,
    cy: 714.65,
    r: 4.31
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 82.16,
    cy: 714.65,
    r: 4.31
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 137.51,
    cy: 755.74,
    r: 4.31
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 43.5,
    cy: 789.17,
    r: 4.31
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-156",
    cx: 307.2,
    cy: 648.43,
    r: 4.31
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 282.93,
    cy: 820.69,
    r: 4.31
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 7.03,
    cy: 669.18,
    r: 2.5
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 135.37,
    cy: 900.72,
    r: 4.25
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 119.01,
    cy: 981.95,
    r: 4.25
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 53.13,
    cy: 883.67,
    r: 9
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 349.33,
    cy: 863.73,
    r: 4.85
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 344.71,
    cy: 959.37,
    r: 4.85
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 836.66,
    cy: 706.13,
    r: 4.31
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 493.97,
    cy: 748.66,
    r: 4.98
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-151",
    cx: 451.08,
    cy: 786.78,
    r: 2.9
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 669.28,
    cy: 693.54,
    r: 4.25
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 611.54,
    cy: 752.98,
    r: 4.25
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 558.59,
    cy: 916.38,
    r: 6,
    transform: "translate(-514.29 889.99) rotate(-57.23)"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 869.2,
    cy: 778.26,
    r: 4.85
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 813.54,
    cy: 856.18,
    r: 4.85
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1088.57,
    cy: 939.48,
    r: 4.31
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 980.17,
    cy: 913.7,
    r: 4.31
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 980.17,
    cy: 913.7,
    r: 4.31
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 980.17,
    cy: 913.7,
    r: 4.31
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 980.17,
    cy: 913.7,
    r: 4.31
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1035.51,
    cy: 872.61,
    r: 4.31
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 941.51,
    cy: 839.18,
    r: 4.31
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 1205.2,
    cy: 979.92,
    r: 4.31
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1180.93,
    cy: 807.66,
    r: 4.31
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 905.04,
    cy: 959.17,
    r: 2.5
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 1033.38,
    cy: 727.63,
    r: 4.25
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 1017.01,
    cy: 646.4,
    r: 4.25
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 951.13,
    cy: 744.68,
    r: 9
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 1247.33,
    cy: 764.62,
    r: 4.85
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 1242.71,
    cy: 668.98,
    r: 4.85
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 1734.67,
    cy: 922.22,
    r: 4.31
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 1391.98,
    cy: 879.69,
    r: 4.98
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-153",
    cx: 1349.08,
    cy: 841.57,
    r: 2.9
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 1567.28,
    cy: 934.81,
    r: 4.25
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1509.55,
    cy: 875.37,
    r: 4.25
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 1456.59,
    cy: 711.97,
    r: 6,
    transform: "translate(-153.54 901.83) rotate(-32.77)"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 1767.2,
    cy: 850.09,
    r: 4.85
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 4.85,
    cy: 772.17,
    r: 4.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTravelMode);
export default __webpack_public_path__ + "static/media/bg-travel-mode.a0a6f34ea9a86c00d7478bddffd95528.svg";
export { ForwardRef as ReactComponent };